import { render, staticRenderFns } from "./OrganInfectionDetailsView.vue?vue&type=template&id=924f96ce"
import script from "./OrganInfectionDetailsView.vue?vue&type=script&lang=js"
export * from "./OrganInfectionDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports